import { Component, OnInit, ViewChild } from '@angular/core';
import { ScanConfiguration } from 'src/app/models/ScanConfigurationModel';
import { ScanConfigurationListComponent } from './scan-configuration-list.component';

@Component({
  selector: 'app-scan-configuration-dashboard',
  templateUrl: './scan-configuration-dashboard.component.html',
  styleUrls: []
})
export class ScanConfigurationDashboardComponent implements OnInit {
  state='LIST';
  selectedScanConfiguration: ScanConfiguration;

  @ViewChild(ScanConfigurationListComponent) notificationList: ScanConfigurationListComponent;

  constructor() { }

  ngOnInit() {
  }

  showList() {
    this.selectedScanConfiguration = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedScanConfiguration = new ScanConfiguration();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedScanConfiguration = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedScanConfiguration = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
